import { useState, useEffect } from "react";

function ToDoInput({addTodo}){

    const [text, setText] = useState("");

    function handleSubmit(e){
        e.preventDefault();
        if (!text.trim()){
            return;
        }
        addTodo(text);
        setText("");
    }
    return(
        <form onSubmit={handleSubmit} className="TodoInputForm">
            <input value={text} onChange={
                (e) => setText(e.target.value)
                } placeholder="Add task" />
            <button type="submit">Add</button>
        </form>
    );
}

export default ToDoInput;
